import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../environments/environment';
import { CapabilityEngineService } from '../capabilityEngine.service';

@Injectable()
export class TeamsListService {

    constructor(
        private http: HttpClient,
        private _capEngineService: CapabilityEngineService
    ) { }

    performPagination(pageNumber) {
        let header = this._capEngineService.getHeaders('viewTeamList');
        return this.http.get(environment.serverUrl + '/teams/pagination/' + pageNumber, header);
    }
}



// WEBPACK FOOTER //
// ./src/app/teams-list/teams-list.service.ts